import { Directive, HostListener } from '@angular/core';

@Directive({
  selector: '[sharedPhoneInput]',
})
export class PhoneInputDirective {
  private readonly phonePattern = /^[+0-9]*$/;
  private readonly allowedKeys = ['+', '0', '1', '2', '3', '4', '5', '6', '7', '8', '9'];

  @HostListener('keypress', ['$event'])
  public onKeypress(event: KeyboardEvent): void {
    if (!this.allowedKeys.includes(event.key)) {
      event.preventDefault();
    }
  }

  @HostListener('paste', ['$event'])
  public onPaste(event: ClipboardEvent): void {
    const clipboardData = event.clipboardData?.getData('text');
    if (clipboardData && !this.phonePattern.test(clipboardData)) {
      event.preventDefault();
    }
  }
}
